import type { Faq } from '../seo/topics'

export function FaqList({ items }: { items: Faq[] }) {
  return (
    <dl className="faq">
      {items.map((item) => (
        <div key={item.q}>
          <dt>{item.q}</dt>
          <dd>{item.a}</dd>
        </div>
      ))}
    </dl>
  )
}
